
import { Marker, Tooltip } from 'react-leaflet';
import useZoomLevel from './useZoomLevel'; 
import { useRef } from 'react';
import { UpdatePonBoxCoordinate } from '../UpdateData/UpdateCommunications';
import { CONST_HIGHWAY, CONST_CANTON, PON_BOX } from '../Constants/ConstantsOptics';
import ShowEditingCoorComponent from '../Drawing/ShowEditingCoorComponent';

const MarkersViewingPonBox = ({ data, icon, layersVisibilityCommunications, isLineDrawing, flag,
  openModalWithContent, statusModalTerritory, highwayFlag, cantonFlag, type, user, cantonRefresh,
  highwayRefresh, isComponentChangeCoor, setIsComponentChangeCoor, showPonLayer, showKtvLayer, showEtherLayer, visibleNumberPonBox}) => {


    const zoomLevel = useZoomLevel();
    const newCoordinates = useRef({}); 
  
    const handleMarkerDragEnd = (event, id) => {
      if (!isComponentChangeCoor) return; 
    
      const { lat, lng } = event.target.getLatLng();
      newCoordinates.current = {};
      newCoordinates.current = { id, lat, lng, type };     
    };
  
    const handleSave = () => {
      const { id, lat, lng, type } = newCoordinates.current;
    
     if(type === PON_BOX) {
      if (statusModalTerritory === CONST_HIGHWAY) {
        UpdatePonBoxCoordinate(id, lat, lng, user, highwayRefresh);
      } else if (statusModalTerritory === CONST_CANTON) {
        UpdatePonBoxCoordinate(id, lat, lng, user, cantonRefresh);
      }
    }else{
      console.log("Не определено ", type);
    }
  
      newCoordinates.current = {};
      setIsComponentChangeCoor(false); 
    };
  
    return (
      <>

{data.map((item, index) => {
  const eventHandlers = {};
  if (!isLineDrawing && !flag) {
    eventHandlers.click = () => {
      let content = '';
      if (statusModalTerritory === CONST_HIGHWAY) {
        content = highwayFlag;
      } else if (statusModalTerritory === CONST_CANTON) {
        content = cantonFlag;
      }
      openModalWithContent(item, content);
    };
  }

  if (zoomLevel <= 16) {
    return null;
  }


  const shouldDisplayMarker =
  layersVisibilityCommunications &&
  (
    (showPonLayer && item.pon === 1) || 
    (showKtvLayer && item.ktv === 1) || 
    (showEtherLayer && item.ether === 1) ||
    (!showPonLayer && !showKtvLayer && !showEtherLayer && item.nodeStatus !== 1)
  );

  if (!shouldDisplayMarker) {
    return null;
  }

  return (
    <Marker
      key={index}
      position={[item.latitude, item.longitude]}
      icon={icon}
      draggable={isComponentChangeCoor}
      eventHandlers={{
        click: eventHandlers.click,
        dragend: (event) => handleMarkerDragEnd(event, item.id),
      }}
    >
    {visibleNumberPonBox && item.numberBox !== null && (
      <Tooltip permanent direction="bottom" offset={[0, 10]} className="custom-tooltipPonNumber">
        {item.numberBox}
      </Tooltip>
    )}
    </Marker>
  );
})}
  
        {/* Компонент для сохранения или отмены изменений */}
        <ShowEditingCoorComponent
          isComponentChangeCoor={isComponentChangeCoor}
          setIsComponentChangeCoor={setIsComponentChangeCoor}
          handleSave={handleSave} 
        />
      </>
    );
  };
  
  export default MarkersViewingPonBox;